import { Button } from "@/components/ui/button";
import { SearchIcon } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useState } from "react";

interface SearchInputProps {
  onSearch?: (query: string) => void;
  className?: string;
  buttonText?: string;
  placeholder?: string;
}

export default function SearchInput({
  onSearch,
  className = "",
  buttonText = "Search",
  placeholder = "Search for machinery...",
}: SearchInputProps) {
  const [query, setQuery] = useState("");

  const handleSearch = () => {
    if (query.trim() && onSearch) {
      onSearch(query.trim());
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className={`flex gap-2 ${className}`}>
      <div className="relative flex-1">
        <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-5 w-5" />
        <Input
          type="text"
          placeholder={placeholder}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          className="pl-10 text-black placeholder:text-gray-500 bg-white border-2 border-white/60 focus:border-white/80 focus:ring-white/50"
        />
      </div>
      <Button
        onClick={handleSearch}
        className="bg-orange-600 hover:bg-orange-700"
      >
        <SearchIcon className="mr-2 h-5 w-5" />
        {buttonText}
      </Button>
    </div>
  );
} 